module.exports = __webpack_public_path__ + "static/media/instamaps_medium.b1281c07.jpg";